import { postToApi } from '../../services'
import Settings from '../../services/Settings'

export const onPostRegistry = (body, token, onSuccess, onError, onPending) => {
  return postToApi(
    body,
    Settings.buildUrl(Settings.urls.apiUsers, Settings.path.sellers),
    onSuccess,
    onError,
    onPending,
    token
  )
}

export const onPostResendEmail = (body, token, onSuccess, onError, onPending) =>{
  return  postToApi(
    body,
    Settings.buildUrl(Settings.urls.apiUsers, Settings.path.resend),
    onSuccess,
    onError,
    onPending,
    token
  )
}